import {
  CdkDrag,
  CdkDragPlaceholder,
  CdkDragPreview,
  CdkDropList,
} from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslationCoreModule } from '@qtek/libs/translation-core';
import { DataTableComponent } from './containers/data-table/data-table.component';
import { ColumnFormatDirective } from './directives';
import { ColumnDefDirective } from './directives/column-def.directive';
import { ColumnResizeDirective } from './directives/column-resize.directive';
import { DetailRowDirective } from './directives/detail-row.directive';
import { GroupRowDirective } from './directives/group-row.directive';
import { HeaderDefDirective } from './directives/header-def.directive';
import { ColumnHeaderPipe } from './pipe/column-header.pipe';
import { TableEmptyStateComponent } from './standalone-components/empty-state/empty-state.component';
import { DataTableLoadingComponent } from './standalone-components/loading/loading.component';

@NgModule({
  imports: [
    CommonModule,
    CdkDrag,
    CdkDragPlaceholder,
    CdkDragPreview,
    CdkDropList,
    MatButtonModule,
    MatCheckboxModule,
    MatDividerModule,
    MatIconModule,
    MatRadioModule,
    MatSortModule,
    MatTableModule,
    MatTooltipModule,
    TranslationCoreModule,
    MatMenuModule,
    TableEmptyStateComponent,
    DataTableLoadingComponent,
    MatBadgeModule,
    ColumnHeaderPipe,
  ],
  declarations: [
    DetailRowDirective,
    GroupRowDirective,
    ColumnDefDirective,
    ColumnFormatDirective,
    ColumnResizeDirective,
    HeaderDefDirective,
    DataTableComponent,
  ],
  exports: [
    DetailRowDirective,
    GroupRowDirective,
    ColumnDefDirective,
    ColumnFormatDirective,
    ColumnResizeDirective,
    HeaderDefDirective,
    DataTableComponent,
  ],
})
export class DataTableModule {}
